import React, { useEffect, useState } from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader';
import PageButtons from '../../../components/pageComponents/PageButtons';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import styled from "styled-components";
import TablePeriodos from "./TablePeriodos";

const AdminListarPeriodosFaltas = () => {

    const [formValues, setFormValues] = useState({ Items: [], ExtraData: {} });
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({ CurrentPage: 1 });
    const [isLoading, setIsLoading] = useState(true);

    const [executeManagePost] = useManagePostRequest();

    const init = async () => {
        setIsLoading(true);
        try {
            await manageSearch();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = `Falta/GetIndexPeriodosFaltas`;
        const payload = getPayload();
        await executeManagePost(api, payload, successManageSearchCallback);
        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage
        }
    }


    const successManageSearchCallback = ({ data }) => {
        const { Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage } = data;
        setFormValues(lastData => ({ ...lastData, Items, ExtraData }));
        setPaginator({ TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage });
        setIsLoading(false);
    }

    const successPostCallback = () => {
        manageSearch();
    }

    const handleCleanSearch = () => {
        setFormValues({ ...formValues });
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage])

    useEffect(() => {
        init();
    }, [])

    const handleNuevo = async () => {
        await executeManagePost("Falta/CreatePeriodosFaltas", null, successPostCallback);
    }

    return (
        <PageWrapper isLoading={isLoading}>
            <PageHeader title="Lista de Periodos" />
            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <PageButtons hasBackButton>
                        {formValues.ExtraData.PuedeCrear &&
                        <button
                            type="button"
                            className="generic-button-buscador"
                            disabled={!formValues.ExtraData.PuedeCrear}
                            onClick={handleNuevo}>Nuevo Periodo</button>
                        }
                        
                    </PageButtons>
                </ButtonsWrapper>
            </SearchContainer>

            <TablePeriodos
                formValues={formValues}
                paginator={paginator}
                setPaginator={setPaginator}
                successPostCallback={successPostCallback}
            />
        </PageWrapper>
    );
}

export default AdminListarPeriodosFaltas;


const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;